import $ from 'jquery';

export function bind() {
  $('#bt-save').on('click', function(evt) {
    evt.preventDefault();
    $('#modal-confirm-stock').modal('show');
  });
}



// WEBPACK FOOTER //
// ./src/modules/saas/aast/product/index.js